// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"2acfe0f5","202":"2acfe0f5","816":"2acfe0f5"}[chunkId] + ".chunk.css";
};